<div class="loading-spinner d-flex justify-content-center" *ngIf="loading">
  <div class="spinner-border" role="status">
      <img src="/assets/img/loader.gif">
    <span class="sr-only">Loading...</span>
  </div>
</div>
